/** Types MIME acceptes pour l'upload de documents dossier */
export const ALLOWED_DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/heic',
  'image/heif',
] as const;

/** Types MIME acceptes pour l'OCR (inclut des formats supplementaires) */
export const ALLOWED_OCR_MIME_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
] as const;

/** Taille maximale d'un fichier upload en octets (5 Mo) */
export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export function isAllowedDocumentMimeType(mime: string): boolean {
  return (ALLOWED_DOCUMENT_MIME_TYPES as readonly string[]).includes(mime.toLowerCase());
}

export function isAllowedOcrMimeType(mime: string): boolean {
  return (ALLOWED_OCR_MIME_TYPES as readonly string[]).includes(mime.toLowerCase());
}
